const GroupCheckIcon = () => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33 1.5C50.397 1.5 64.5 15.603 64.5 33C64.5 50.397 50.397 64.5 33 64.5C15.603 64.5 1.5 50.397 1.5 33C1.5 15.603 15.603 1.5 33 1.5Z"
        fill="#EBFFF9"
        stroke="#0ABB89"
        stroke-width="3"
      />
      <path
        d="M48.7348 19.1988C49.9784 17.8664 52.0666 17.7944 53.399 19.0379C54.7313 20.2815 54.8034 22.3697 53.5598 23.7021L30.4598 48.4521C29.2533 49.7448 27.2423 49.8567 25.8997 48.706L14.3497 38.806C12.9659 37.6199 12.8057 35.5366 13.9918 34.1528C15.1779 32.769 17.2612 32.6088 18.6449 33.7949L27.7932 41.6362L48.7348 19.1988Z"
        fill="#0ABB89"
      />
</svg>
  )
}

export { GroupCheckIcon }
